import styled from 'styled-components';
import { Drawer, Button } from 'antd';

export const StyledDrawer = styled(Drawer)`
	.ant-drawer-body {
		padding: 32px 40px;
	}

	.ant-drawer-header {
		padding: 16px 24px;
		border-bottom: 1px solid #e6e6e6;
	}

	.ant-drawer-title div {
		font-size: 14px;
		font-weight: 500;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.close-icon {
		font-size: 14px;
		cursor: pointer;
		transition: color 0.3s;

		&:hover {
			color: #2f54eb;
		}
	}
`;

export const VideoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 100%;
`;

export const VideoPlayerWrapper = styled.div`
	width: 100%;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.25);
	height: 250px;
`;

export const InfoSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const InfoItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const InfoLabel = styled.p`
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
	color: #262626;
	margin: 0;
`;

export const InfoValue = styled.p`
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	color: #262626;
	margin: 0;
`;

export const CloseButton = styled(Button)`
	border-radius: 4px;
	font-weight: 400;
	font-size: 16px;
	height: 40px;
	border: 1px solid #e6e6e6;
	background-color: #ffffff;
	color: #262626;

	&:hover {
		border-color: #2f54eb;
		color: #2f54eb;
	}
`;
